import Icon from '../../components/Icon.vue'

Icon.register({"regular/id-badge":{"width":384,"height":512,"paths":[{"d":"M0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V48C384 21.5 362.5 0 336 0H48C21.5 0 0 21.5 0 48zM336 80V458A6-6 0 0 0 330 464H54A6-6 0 0 0 48 458V80H336zM192 160C230.7 160 262 191.3 262 230S230.7 300 192 300 122 268.7 122 230 153.3 160 192 160zM272.2 306L241 298.2C208.2 321.8 168.5 316.6 143 298.2L111.8 306C93.1 310.7 80 327.5 80 346.8V363C80 374.6 89.4 384 101 384H283C294.6 384 304 374.6 304 363V346.8C304 327.5 290.9 310.7 272.2 306z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/id-badge.js
// module id = null
// module chunks = 